import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'
import propertyService from '../../../../services/property.service'
import {
  MaskedProperty,
  Property,
  PropertyWithAccess,
} from '../../../../types/Property/Property'
import { classNames } from '../../../../lib/utils/classNames'

type ContributorsCountProps = {
  property: PropertyWithAccess | Property | MaskedProperty
  smallText?: boolean
}

export default function ContributorsCount({
  smallText,
  property,
}: ContributorsCountProps) {
  const { t } = useTranslation('originals/global')

  const [contributorsCount, setContributorsCount] = useState<number>(0)
  const [contributorsCountLoading, setContributorsCountLoading] =
    useState<boolean>(true)
  const isFundingClosed = ['funded', 'reimbursed'].includes(
    property.fundingStatus,
  )

  const fetchContributorsCount = async (propertyId: string) => {
    setContributorsCountLoading(true)
    const contributors = await propertyService.getContributorsCount(propertyId)
    setContributorsCount(contributors.count)
    setContributorsCountLoading(false)
  }

  useEffect(() => {
    fetchContributorsCount(property.id)
  }, [property])

  return (
    <>
      {contributorsCountLoading ? (
        <></>
      ) : (
        <div
          className={`${smallText ? `text-xs` : 'text-sm'} flex items-center`}
        >
          <img
            src="/img/icons/3d/users-min.png"
            className={classNames('-rotate-6', smallText ? 'h-5' : 'h-7')}
            alt="house icon 3d"
          />
          {isFundingClosed && (
            <p className="text-neutralBlack/90">
              {t('financingProgress.contribution.financedBy')}{' '}
              <span className="font-medium">{contributorsCount}</span>{' '}
              {t('financingProgress.contribution.contributors')}
            </p>
          )}
          {!isFundingClosed && contributorsCount === 0 && (
            <p className="text-neutralBlack/90">
              {t('financingProgress.contribution.beTheFirstContributor')}
            </p>
          )}
          {!isFundingClosed && contributorsCount === 1 && (
            <p className="text-neutralBlack/90">
              {t('financingProgress.contribution.already')}{' '}
              <span className="font-medium">{contributorsCount}</span>{' '}
              {t('financingProgress.contribution.contributor')}
            </p>
          )}
          {!isFundingClosed && contributorsCount > 1 && (
            <p className="text-neutralBlack/90">
              {t('financingProgress.contribution.already')}{' '}
              <span className="font-medium">{contributorsCount}</span>{' '}
              {t('financingProgress.contribution.contributors')}
            </p>
          )}
        </div>
      )}
    </>
  )
}
